/* spx-agotado-limpio — una ficha agotada no promete despacho (26/09/2026, OK de Martin).
 *
 * En las 3 tiendas la ficha de un producto AGOTADO seguía diciendo «Cómpralo ahora y sale el lunes» y
 * «Con este producto tienes despacho gratis a todo Chile» (los avisos #ux-hoy-caja / #ux-envio-caja, y
 * #lhx-… en Lhotse). Se esconden mientras la variante elegida esté agotada, y vuelven si se elige una con
 * stock. Martin eligió «fichas agotadas honestas» en unionx.cl; se replica en Lhotse y Simplit.
 * Fuente única: areas/paginas-propias/_comun/tema/spx-agotado-limpio.js
 */
(function () {
  var h = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
  if (!h || window.__spxAgotadoLimpio) return;
  window.__spxAgotadoLimpio = 1;
  var s = document.createElement('style');
  s.textContent = 'html.spx-var-agotada #ux-hoy-caja,html.spx-var-agotada #ux-envio-caja,' +
    'html.spx-var-agotada #lhx-hoy-caja,html.spx-var-agotada #lhx-envio-caja{display:none!important}';
  document.head.appendChild(s);
  var P = null;
  function actual() {
    var f = [].filter.call(document.querySelectorAll('form[action*="/cart/add"]'), function (x) {
      return !x.closest('#mini-cart, .ajax-cart__drawer-wrapper, .modal, [role=dialog], dialog, product-card, .quick-add') && x.offsetParent !== null;
    })[0];
    var id = (f && f.querySelector('[name=id]') && f.querySelector('[name=id]').value) || new URLSearchParams(location.search).get('variant');
    return P.variants.filter(function (v) { return String(v.id) === String(id); })[0] ||
      P.variants.filter(function (v) { return v.available; })[0] || P.variants[0];
  }
  function marcar() { if (P) document.documentElement.classList.toggle('spx-var-agotada', !actual().available); }
  fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (p) {
      if (!p || !p.variants) return;
      P = p; marcar();
      var tick = function () { setTimeout(marcar, 400); };
      document.addEventListener('change', tick); document.addEventListener('click', tick);
    }).catch(function () {});
})();
